import { render, staticRenderFns } from "./DistributionReport.vue?vue&type=template&id=0481780a&scoped=true"
import script from "./DistributionReport.vue?vue&type=script&lang=js"
export * from "./DistributionReport.vue?vue&type=script&lang=js"
import style0 from "./DistributionReport.vue?vue&type=style&index=0&id=0481780a&prod&lang=css"
import style1 from "./DistributionReport.vue?vue&type=style&index=1&id=0481780a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0481780a",
  null
  
)

export default component.exports